module.exports = __webpack_public_path__ + "img/rect3.55d98d13.png";